<template>
<div class="delete">
	<button class="delete__button" type="button" @click="showConfirm" :class="{active: confirm}" title="Удалить">
		<svg enable-background="new 0 0 31.444 31.444" version="1.1" viewBox="0 0 31.444 31.444" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
			<path d="m1.119 16.841c-0.619 0-1.111-0.508-1.111-1.127s0.492-1.111 1.111-1.111h13.475v-13.476c1e-3 -0.619 0.509-1.127 1.128-1.127s1.111 0.508 1.111 1.127v13.476h13.475c0.619 0 1.127 0.492 1.127 1.111s-0.508 1.127-1.127 1.127h-13.475v13.476c0 0.619-0.492 1.127-1.111 1.127s-1.127-0.508-1.127-1.127v-13.476h-13.476z" fill="#1E201D"/>
		</svg>
	</button>
	<button class="delete__button confirm" :class="{active: confirm}" type="button" @click="$emit('click')" title="Подтвердите удаление">
		<svg enable-background="new 0 0 31.444 31.444" version="1.1" viewBox="0 0 31.444 31.444" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
			<path d="m1.119 16.841c-0.619 0-1.111-0.508-1.111-1.127s0.492-1.111 1.111-1.111h13.475v-13.476c1e-3 -0.619 0.509-1.127 1.128-1.127s1.111 0.508 1.111 1.127v13.476h13.475c0.619 0 1.127 0.492 1.127 1.111s-0.508 1.127-1.127 1.127h-13.475v13.476c0 0.619-0.492 1.127-1.111 1.127s-1.127-0.508-1.127-1.127v-13.476h-13.476z" fill="#1E201D"/>
		</svg>
	</button>
</div>
</template>

<script>
import tooltip from '../../components/Tooltip.vue'

export default {
	components: {
		tooltip
	},
	data() {
		return {
			confirm: false
		}
	},
	methods: {
		showConfirm() {
			this.confirm = true;
		}
	},
}
</script>



<style lang="scss" scoped>
@import './../../styles/variables.scss';
.delete {
	position: relative;
	width: 25px;
	height: 25px;

	&__button {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: white;
	font-size: 18px;
	min-width: 25px;
	height: 25px;
	border: none;
	border-radius: 50%;
	background-color: #c4c4c4;
	box-shadow: 0px 5px 10px -1px rgba(0, 0, 0, 0.25);
	transition: all 200ms;
	outline: none;
	cursor: pointer;

	.dark & {
		background-color: $dark-text;
	}



	&.confirm {
		position: absolute;
		top: 0;
		right: 0;
		opacity: 0;
		transform: translateX(-100%);
		pointer-events: none;

		&:hover {
			background-color: #cf3849;
			path {
			fill: black;
			}

			.dark &  path{
				fill: black;
			}
		}

		&.active {
			position: absolute;
			pointer-events: all;
			top: 0;
			right: 0;
			width: 100%;
			opacity: 1;
			transform: translateX(0);
			background-color: #e46c7b;
		}
	}


  &:hover {
		background-color: white;
		transform: scale(1.2);
		color: #3a3bf8;

		path {
			fill: #e46c7b;

			.dark & {
				fill: #e46c7b;
			}
		}
	}
}

svg {
  width: 15px;
  height: 15px;
  transform: rotate(45deg);

  path {
	fill: white;

	.dark & {
		fill: $dark-grey;
	}
  }
}

}

</style>